import { Rule } from '@mui/icons-material';
import { guard } from '../RequirePermission';
import { PolicyList } from './PolicyList';
import { PolicyShow } from './PolicyShow';
import { PolicyCreate } from './PolicyCreate';
import { PolicyEdit } from './PolicyEdit';

export { PolicyList } from './PolicyList';
export { PolicyShow } from './PolicyShow';
export { PolicyCreate } from './PolicyCreate';
export { PolicyEdit } from './PolicyEdit';
export { PolicyForm } from './PolicyForm';

export const reservationPoliciesResource = {
    list: guard('reservation-policies:read:all', PolicyList),
    show: guard('reservation-policies:read:all', PolicyShow),
    create: guard('reservation-policies:write:all', PolicyCreate),
    edit: guard('reservation-policies:write:all', PolicyEdit),
    icon: Rule,
    recordRepresentation: 'id',
    meta: { permissions: ['reservation-policies:read:all', 'reservation-policies:write:all'] as const },
};
